<template>
    <div>
        <StepContainer>
            <div class="step3-box" v-if="showUserInfo && !userInfoStatus">
                <div class="separate">
                    <div class="apps-box">
                        <div class="name">请选择接收游戏：</div>
                        <Select class="select-box" v-model="to_app" filterable>
                            <Option v-for="(item, key) in toApps.info" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                        <Prompt class="prompt" :options="toAppsPrompt"/>
                    </div>

                    <div class="type-box">
                        <div class="name">可领取的补偿码类型：</div>
                        <div class="txt">第{{level}}档奖励</div>
                    </div>
                </div>
                <div class="separate">
                    <div class="servers-box">
                        <div class="name">请选择区服：</div>
                        <Select class="select-box" v-model="to_sid" filterable>
                            <Option v-for="item in chooseServers.info" :value="item.sid" :key="item.sid">{{ item.servers_name }}</Option>
                        </Select>
                        <Prompt :options="serversPrompt"/>
                        <div class="prompt" v-show="showPrompt">正在获取服务器...</div>
                    </div>

                    <div class="user-box" v-show="userTitle">
                        <div class="name">请输入{{userTitle}}：</div>
                        <input type="text" :placeholder="`您的${userTitle}`" v-model="to_pid" @keydown="pid_verified = false" @keyup="checkUser">
                        <Prompt class="prompt" :options="userPrompt"/>
                    </div>
                </div>
            </div>
            <button class="submit" @click="submit" v-if="showUserInfo && !userInfoStatus">确定</button>
            <div class="userInfoStatus" v-if="showUserInfo && userInfoStatus">{{userInfoStatus}}</div>
        </StepContainer>
        <div class="record-box" v-if="record.to_app">
            <div class="title">
                我的领取记录
            </div>
            <div class="inner-container">
                <p>账号：{{record.user_name}}</p>
                <p>接收游戏：{{record.to_app}}</p>
                <p>补偿获取时间：{{record.send_time}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import StepContainer from '@/views/step-container';
import * as api from '@/api/index'
import store from '@/store';
import Prompt from '@/components/prompt';
import {debounce} from 'lodash'

export default {
    components: {
        StepContainer,
        // Select,
        Prompt
    },
    data () {
        return {
            game: '',
            way: '',
            token: '',
            userTitle: '',
            to_app: '',
            to_sid: '',
            to_pid: '',
            pid_verified: false,

            level: 0,
            showUserInfo: false,
            userInfoStatus: '',  // 转服状态
            record: {
                user_name: '',
                to_app: '',
                send_time: ''
            },

            sharedState: store.state,
            gameInfo: {},
            showPrompt: false,
            toApps: {
                placeholder: '选择接收的游戏',
                info: {}
            },
            chooseServers: {
                placeholder: '请选择区服',
                info: []
            },

            toAppsPrompt: {
                type: '',
                msg: ''
            },
            serversPrompt: {
                type: '',
                msg: ''
            },
            userPrompt: {
                type: '',
                msg: ''
            }
        }
    },
    created () {
        this.game = this.$route.query.app
        this.way = this.$route.query.way
        this.token = this.$route.query.token

        this.getUserInfo()  // 获取奖励档位
    },
    watch: {
        sharedState: {
            handler: function(newVal) {
                // 监听到store有数据后，再去获取store中的接收游戏列表
                if(newVal && newVal.gameList.length != 0) {
                    this.game = this.$route.query.app
                    this.getToAppsInfo(this.game, newVal.gameList)  // 获取该游戏可接收的游戏
                }
            },
            immediate: true,
            deep: true
        },
        to_app (newVal) {
            this.toAppsPrompt = {
                type: '',
                msg: ''
            }
            this.setUserTitle(newVal)
            this.getServers(newVal)
        },
        to_sid (newVal) {
            if(newVal) {
                this.serversPrompt = {
                    type: '',
                    msg: ''
                }

                if(this.to_pid) {
                    this.checkUser()
                }
            }
        },
    },
    methods: {
        async getUserInfo () {
            let data = {
                choose_app: this.game,
                oauth_type: this.way,
                token: this.token
            }
            let result = await api.reqUserInfo(data)
            if(result.status == 200) {
                // 有转服资格，且未领取补偿
                if(result.data.level) {
                    this.level = result.data.level
                }
                if(result.data.to_app) {
                    // 有转服资格，且领取过奖励
                    this.userInfoStatus = '您的转服补偿已全部领取完毕，可在领取记录中查看结果'
                    this.record = result.data
                }

                this.showUserInfo = true
            }else {
                // 没有转服资格
                this.userInfoStatus = result.data

                this.showUserInfo = true
            }
        },
        getToAppsInfo (game, gameList) {
            gameList.map(item => {
                if(game == item.app) {
                    this.toApps.info = item.to_apps
                }
            })
        },
        async getServers (to) {
            if(to) {
                this.showPrompt = true

                let result = await api.reqServers(to)
                if(result.status == 200) {
                    this.chooseServers.info = result.data
                    this.showPrompt = false
                }else {
                    this.serversPrompt = {
                        type: 'error',
                        msg: result.data
                    }
                }
            }
        },
        setUserTitle(game) {
            if(game == 'ro' || game == 'hsqj') {
                this.userTitle = '角色名'
            }
            if(game == 'xcpd' || game == 'boli' || game == 'wulala') {
                this.userTitle = '游戏ID'
            }
            if(game == 'ae') {
                this.userTitle = '用户ID'
            }
            if(game == '') {
                this.userTitle = ''
            }
        },
        checkUser: debounce(async function() {
            let checked = this.checkData()
            if(checked) {
                let data = {
                    choose_app: this.game,
                    oauth_type: this.way,
                    to_app: this.to_app,
                    to_sid: this.to_sid,
                    to_pid: this.to_pid,
                    token: this.token
                }

                // 清空处理
                this.userPrompt = {
                    type: 'default',
                    msg: '验证中...'
                }

                // 请求
                let result = await api.reqCheckUser(data)
                if(result.status == 200) {
                    this.pid_verified = true
                    // 成功处理
                    this.userPrompt = {
                        type: 'success',
                        msg: '验证通过'
                    }
                }else{
                    this.pid_verified = false
                    this.userPrompt = {
                        type: 'error',
                        msg: result.data
                    }
                }
            }
        },500),
        checkData () {
            let checked = true
            
            if(!this.to_app) {
                this.toAppsPrompt = {
                    type: 'error',
                    msg: '请选择有效的接收游戏'
                }
                checked = false
            }
            if(!this.to_sid) {
                this.serversPrompt = {
                    type: 'error',
                    msg: '请选择有效的区服'
                }
                checked = false
            }
            if(!this.to_pid) {
                this.userPrompt = {
                    type: 'error',
                    msg: `请输入${this.userTitle}`
                }
                checked = false
            }

            return checked
        },
        async reqTransfer (data) {
            let result = await api.transferSubmit(data)
            if(result.status == 200) {
                // 成功处理
                alert(result.message ? result.message : '领取成功')
            }else {
                alert(result.data)
            }
        },
        submit () {
            let checked = this.checkData()
            if(checked && this.pid_verified) {
                let data = {
                    choose_app: this.game,
                    oauth_type: this.way,
                    to_app: this.to_app,
                    to_sid: this.to_sid,
                    to_pid: this.to_pid,
                    token: this.token
                }

                data.token = this.token
                this.reqTransfer(data)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@mixin set_prompt {
    position: relative;
    .prompt {
        position: absolute;
        bottom: -25px;
        font-size: 12px;
    }
}

.step3-box {
    display: flex;
    justify-content: space-between;
    .separate {
        width: 350px;
        .name {
            margin-bottom: 15px;
        }

        .apps-box,
        .servers-box {
            margin-bottom: 70px;
            @include set_prompt();
        }

        .type-box {
            .txt {
                color: $reward;
            }
        }

        .user-box {
            input {
                color: #515a6e;
                border: 1px solid #ECECEC;
                width: 260px;
                height: 40px;
                line-height: 40px;
                border-radius: 5px;
                padding-left: 10px;
                font-size: 15px;
            }
            @include set_prompt();
        }
    }
}
.submit {
    display: block;
    width: 290px;
    height: 46px;
    line-height: 46px;
    border-radius: 23px;
    text-align: center;
    margin: 110px auto 20px;
    background-color: $active;
    color: #fff;
    cursor: pointer;
    transition: all ease-in-out 200ms;
    outline: none;
    border: none;
    &:hover {
        background-color: #F29361;
    }
}

.userInfoStatus {
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    border: 1px solid #E4EDEB;
    border-radius: 5px;
    background-color: #F3FAF8;
    color: #57B99D;
    padding-left: 30px;
}

.record-box {
    width: 900px;
    margin: 40px auto;
    border: 1px solid $border;
    color: $black_txt;
    border-radius: 5px;
    .title {
        height: 60px;
        line-height: 60px;
        padding-left: 20px;
        font-size: 20px;
        border-bottom: 1px solid $border;
    }
    .inner-container {
        padding: 15px 40px;
        font-size: 14px;
        p {
            margin: 8px 0;
        }
    }
}

@media screen and (max-width: 900px) {
    .step3-box {
        .separate {
            width: 260px;
        }
    }
}
@media screen and (max-width: 768px) {
    .step3-box {
        display: block;
        .separate {
            margin: 0 auto;
            .name {
                margin-bottom: 5px;
            }

            .apps-box,
            .type-box,
            .servers-box {
                margin-bottom: 30px;
            }
        }
    }
    .submit {
        margin-top: 60px;
    }
}
</style>